<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
#app {
  width: 100%;
  height: 100vh;
}
.el-scrollbar__wrap {
  overflow-x: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue